/**
 * Cart Drawer - Harber London
 * Optimized: removed blocking AJAX, unnecessary delays, fixed class mismatch,
 * added error handling, parallelized requests, event delegation.
 */
(function($) {
  'use strict';

  /* ============================================
     Cart Drawer Navigation
     ============================================ */

  function openNav() {
    updatecart();
    $(".cart_ajax_new").addClass("ajax_new_active");
    $(".CartDrawer-overlay").addClass("CartDrawer-overlay--active");
    $("body").css("overflow-y", "hidden");
  }

  function closeNav() {
    $(".cart_ajax_new").removeClass("ajax_new_active");
    $(".CartDrawer-overlay").removeClass("CartDrawer-overlay--active");
    $("body").css("overflow-y", "");
  }

  /* ============================================
     Cart AJAX Operations
     /cart/change.js returns the full cart object,
     so we render directly from its response
     instead of making a second GET to /cart.js.
     ============================================ */

  function increasecart(productid, qtyitem) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { quantity: qtyitem + 1, id: productid },
      dataType: 'json',
      success: function(data) {
        renderCart(data);
      },
      error: function() {}
    });
  }

  function removecart(productid, qtyitem) {
    if (qtyitem > 1) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: { quantity: qtyitem - 1, id: productid },
        success: function(data) {
          renderCart(data);
        },
        error: function() {}
      });
    } else {
      removeproduct(productid);
    }
  }

  function removeproduct(productid) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { quantity: 0, id: productid },
      success: function(data) {
        renderCart(data);
      },
      error: function() {}
    });
  }

  function addproduct(productid, gift_message) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { quantity: 1, id: productid },
      properties: { 'Gift_Message': gift_message },
      dataType: 'json',
      success: function() {
        updatecart();
      },
      error: function() {}
    });
  }

  /* ============================================
     Shopify image URL helper
     ============================================ */

  function getOptimizedImageUrl(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + '$1$2');
  }

  /* ============================================
     Build cart item HTML
     ============================================ */

  function buildCartItemHtml(item, isPreorder) {
    var totalPrice = theme.Currency.formatMoney(item.final_price, StyleHatch.currencyFormat);
    var variantTitle = item.variant_title || '';
    var imgSrc = getOptimizedImageUrl(item.image, '120x');
    var escapedTitle = $('<span>').text(item.product_title).html();

    return '<div class="cart-item gift-' + item.id + '">' +
      '<button class="del-item" data-action="remove" data-item-id="' + item.id + '" type="button" aria-label="Remove ' + escapedTitle + '">&#10005;</button>' +
      '<p class="custom--preorder--parent" data-id="' + item.variant_id + '">' +
        (isPreorder ? '<em class="custom--preorder">pre-order</em>' : '') +
      '</p>' +
      '<div class="cart-item__row">' +
        '<div class="cart-item__image product-img">' +
          '<img src="' + imgSrc + '" alt="' + escapedTitle + '" width="120" height="120">' +
        '</div>' +
        '<div class="cart-item__details">' +
          '<p class="product-title-cart">' + escapedTitle + '</p>' +
          (variantTitle ? '<div class="variant-title"><p>' + $('<span>').text(variantTitle).html() + '</p></div>' : '') +
          '<div class="qty-input">' +
            '<button class="qty-count qty-count--minus" data-action="decrease" data-item-id="' + item.id + '" data-item-qty="' + item.quantity + '" type="button" aria-label="Decrease quantity">-</button>' +
            '<input class="product-qty" type="number" name="product-qty" min="0" value="' + item.quantity + '" aria-label="Quantity">' +
            '<button class="qty-count qty-count--add" data-action="increase" data-item-id="' + item.id + '" data-item-qty="' + item.quantity + '" type="button" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="container-price">' +
            (item.original_price > item.final_price
              ? '<p class="original-price" style="text-decoration:line-through;opacity:0.6;position:absolute;right:6px;bottom:19px;">' +
                  '<span class="money conversion-bear-money" data-amount="' + (item.original_price / 100) + '"><span class="money">' + (item.original_price / 100).toFixed(2) + '</span></span></p>'
              : '') +
            '<p class="final-price"><span class="money conversion-bear-money" data-amount="' + (item.final_price / 100) + '">' + totalPrice + '</span></p>' +
          '</div>' +
        '</div>' +
      '</div>' +
      (item.properties && item.properties.Preorder
        ? '<div class="pre-wrapper-btn"><span class="pre-info">' + $('<span>').text(item.properties.Preorder).html() + '</span></div>'
        : '') +
    '</div>';
  }

  /* ============================================
     Preorder detection
     Cached list of variant IDs with stock ≤ 0
     fetched from /cart?view=json (Liquid template).
     ============================================ */

  var preorderVariantIds = [];

  function fetchPreorderIds() {
    return $.ajax({
      type: 'GET',
      url: '/cart?view=json',
      dataType: 'html',
      timeout: 2000
    }).done(function(r) {
      try {
        var arr = $(r).filter(".custom---data").text().split(",");
        preorderVariantIds = (arr.length > 0 && arr[0] !== '') ? arr : [];
      } catch (e) {
        preorderVariantIds = [];
      }
    });
  }

  /* ============================================
     Render cart from data (no network request)
     Uses cached preorderVariantIds — no flash.
     ============================================ */

  function renderCart(data) {
    var itm = data.item_count > 1 ? " items" : " item";
    $("#custom-cart-count").text(data.item_count + itm);
    $("#CartCount").text(data.item_count);

    var carttotal = theme.Currency.formatMoney(data.total_price, StyleHatch.currencyFormat);
    $("#custom-cart-subtotal, #CartCost").html(
      '<span class="money conversion-bear-money" data-amount="' + (data.total_price / 100) + '">' + carttotal + '</span>'
    );

    var html = '';
    for (var i = 0; i < data.items.length; i++) {
      var isPreorder = preorderVariantIds.indexOf(String(data.items[i].variant_id)) !== -1;
      html += buildCartItemHtml(data.items[i], isPreorder);
    }
    $("#custom-cart-items").html(html);
  }

  /* ============================================
     Update Cart (full refresh — used only on open)
     Fetches cart + preorder IDs in parallel.
     ============================================ */

  function updatecart() {
    $.when(
      $.getJSON('/cart.js'),
      fetchPreorderIds()
    ).then(
      function(cartResult) { renderCart(cartResult[0]); },
      function() {
        $.getJSON('/cart.js').done(function(data) { renderCart(data); });
      }
    );
  }

  /* ============================================
     Cart UI Event Handlers (event delegation)
     ============================================ */

  $(document).ready(function() {
    $("#cart_ajax_new").on('click', '[data-action]', function() {
      var action = $(this).data('action');
      var itemId = $(this).data('item-id');
      var itemQty = $(this).data('item-qty');

      switch (action) {
        case 'remove':
          removeproduct(itemId);
          break;
        case 'decrease':
          removecart(itemId, itemQty);
          break;
        case 'increase':
          increasecart(itemId, itemQty);
          break;
        case 'close-cart':
          closeNav();
          break;
      }
    });

    $("#inst_box_display").click(function() {
      $("#CartSpecialInstructions").toggleClass('show_instruatcion');
    });

    $("#gift").click(function() {
      var productid = $("#gift").attr("data-gift-id");
      var gift_message = $("#CartSpecialInstructions").val();
      if ($("#gift").is(":checked")) {
        addproduct(productid, gift_message);
      } else {
        removeproduct(productid);
      }
    });

    $(".default-cart-button__button").click(function() {
      $(".cart_ajax_new").addClass("ajax_new_active");
      $(".CartDrawer-overlay").addClass("CartDrawer-overlay--active");
      $("body").css("overflow-y", "hidden");

      var prevCount = parseInt($("#CartCount").text()) || 0;

      var ogTitle = $('meta[property="og:title"]').attr('content') || '';

      var variantId = $('select[name="id"].custom_original_select_select').val();
      var variantOpt = variantId ? $('#all_id_variant option[value="' + variantId + '"]') : $();

      var imgSrc = variantOpt.attr('image') || $('meta[property="og:image"]').attr('content') || '';

      var variantTitle = '';
      if (variantOpt.length) {
        variantTitle = $.trim(variantOpt.text());
        if (variantTitle === 'Default Title') variantTitle = '';
      }

      var priceInCents = parseInt(variantOpt.attr('price')) || 0;
      var comparePriceInCents = parseInt(variantOpt.attr('cprice')) || 0;

      var selectedMainOpt = $('select[name="id"].custom_original_select_select option:selected');
      var variantQty = parseInt(selectedMainOpt.attr('data-qyt')) || 0;
      var variantPolicy = selectedMainOpt.attr('data-policy') || '';
      var isPreorder = (variantQty <= 0 && variantPolicy === 'continue');

      if (ogTitle) {
        var escapedTitle = $('<span>').text(ogTitle).html();
        var escapedVariant = variantTitle ? $('<span>').text(variantTitle).html() : '';

        var priceHtml = '';
        if (priceInCents > 0) {
          var formattedPrice = theme.Currency.formatMoney(priceInCents, StyleHatch.currencyFormat);
          priceHtml = '<div class="container-price">';
          if (comparePriceInCents > priceInCents) {
            priceHtml += '<p class="original-price" style="text-decoration:line-through;opacity:0.6;position:absolute;right:6px;bottom:19px;">' +
              '<span class="money">' + theme.Currency.formatMoney(comparePriceInCents, StyleHatch.currencyFormat) + '</span></p>';
          }
          priceHtml += '<p class="final-price"><span class="money">' + formattedPrice + '</span></p></div>';
        }

        var tempHtml = '<div class="cart-item cart-item--temp">' +
          '<button class="del-item" type="button" aria-label="Remove ' + escapedTitle + '" style="pointer-events:none">&#10005;</button>' +
          '<p class="custom--preorder--parent">' +
            (isPreorder ? '<em class="custom--preorder">pre-order</em>' : '') +
          '</p>' +
          '<div class="cart-item__row">' +
            (imgSrc
              ? '<div class="cart-item__image product-img"><img src="' + imgSrc + '" width="120" height="120"></div>'
              : '') +
            '<div class="cart-item__details">' +
              '<p class="product-title-cart">' + escapedTitle + '</p>' +
              (escapedVariant ? '<div class="variant-title"><p>' + escapedVariant + '</p></div>' : '') +
              '<div class="qty-input">' +
                '<button class="qty-count qty-count--minus" type="button" aria-label="Decrease quantity">-</button>' +
                '<input class="product-qty" type="number" name="product-qty" min="0" value="1" aria-label="Quantity" readonly>' +
                '<button class="qty-count qty-count--add" type="button" aria-label="Increase quantity">+</button>' +
              '</div>' +
              priceHtml +
            '</div>' +
          '</div>' +
        '</div>';

        $("#custom-cart-items").prepend(tempHtml);

        var newCount = prevCount + 1;
        $("#CartCount").text(newCount);
        $("#custom-cart-count").text(newCount + (newCount > 1 ? " items" : " item"));

        if (priceInCents > 0) {
          var currentTotal = parseFloat($("#custom-cart-subtotal .money").attr('data-amount') || '0') * 100;
          var newTotal = currentTotal + priceInCents;
          var formattedTotal = theme.Currency.formatMoney(newTotal, StyleHatch.currencyFormat);
          $("#custom-cart-subtotal, #CartCost").html(
            '<span class="money conversion-bear-money" data-amount="' + (newTotal / 100) + '">' + formattedTotal + '</span>'
          );
        }
      }

      (function poll(retries) {
        $.getJSON('/cart.js', function(cart) {
          if (cart.item_count > prevCount || retries <= 0) {
            var preorderDone = false, imagesDone = false, rendered = false;

            function tryRender() {
              if (preorderDone && imagesDone && !rendered) {
                rendered = true;
                requestAnimationFrame(function() { renderCart(cart); });
              }
            }

            fetchPreorderIds().always(function() {
              preorderDone = true;
              tryRender();
            });

            var srcs = cart.items.map(function(item) {
              return getOptimizedImageUrl(item.image, '120x');
            }).filter(Boolean);

            if (srcs.length === 0) {
              imagesDone = true;
              tryRender();
            } else {
              var loaded = 0;
              srcs.forEach(function(src) {
                var img = new Image();
                img.onload = img.onerror = function() {
                  if (++loaded >= srcs.length) { imagesDone = true; tryRender(); }
                };
                img.src = src;
              });
              setTimeout(function() { imagesDone = true; tryRender(); }, 500);
            }

            setTimeout(function() {
              if (!rendered) { rendered = true; renderCart(cart); }
            }, 3000);
          } else {
            setTimeout(function() { poll(retries - 1); }, 250);
          }
        });
      })(8);
    });

    $("#CartButton").click(function() {
      openNav();
    });

    $(".CartDrawer-overlay").click(function() {
      closeNav();
    });

    $("#Go_Checkout").click(function() {
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: { note: $("#CartSpecialInstructions").val() },
        success: function() {
          window.location.href = '/checkout';
        },
        error: function() {
          window.location.href = '/checkout';
        }
      });
    });

    $('.close-cookies').click(function() {
      Cookies.set('custom_cookies', 'accepted');
      window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    });

    $('.reject-cookies').click(function() {
      Cookies.set('custom_cookies', 'rejected');
      window.__rmcp2 = [];
      $('.popup.cookies').hide();
    });

    var checkCookie = Cookies.get('custom_cookies');
    if (checkCookie === 'accepted') {
      window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    } else if (checkCookie === 'rejected') {
      $('.popup.cookies').hide();
      window.__rmcp2 = [];
    }

    $(".product-swatches__link").click(function() {
      var src = $(this).attr("data-variant-secondimage");
      $(this).parent().parent().parent().find('.product_card').find('.custom_second_image_parent').attr("data-srcset", src);
    });
  });

  /* ============================================
     Preorder Line Item (replaces setInterval)
     ============================================ */

  (function() {
    function checkPreorder() {
      var addToCartBtn = document.querySelector('[data-addtocarttext]');
      if (!addToCartBtn) return;

      if (addToCartBtn.textContent.trim() === 'Pre-order') {
        if (!document.querySelector('.preorderLineItem')) {
          var preInfo = document.querySelector('.shopify-product-form .pre-info');
          var preInfoText = preInfo ? preInfo.textContent : '';
          var form = document.querySelector('.shopify-product-form');
          if (form) {
            var p = document.createElement('p');
            p.className = 'preorderLineItem line-item-property__field';
            p.style.display = 'none';
            p.innerHTML = '<input id="your-name" type="text" name="properties[Preorder]" value="' + preInfoText + '">';
            form.insertBefore(p, form.firstChild);
          }
        }
      } else {
        var existing = document.querySelector('.preorderLineItem');
        if (existing) existing.remove();
      }
    }

    var observer = new MutationObserver(function() {
      checkPreorder();
    });

    var target = document.querySelector('.shopify-product-form') || document.body;
    observer.observe(target, { childList: true, subtree: true, characterData: true });
    checkPreorder();
  })();

  /* ============================================
     Image Popup (mobile)
     ============================================ */

  $(".close-popup-show").click(function() {
    $(".show-popup").fadeOut();
  });

  $(document).on('click', '.product-image--slider a', function(e) {
    if (window.innerWidth < 769) {
      e.preventDefault();
      $(".show-popup").fadeIn();
      $(".img-show img").attr("src", $(this).attr('href'));
    }
  });

  /* ============================================
     Product Image Zoom
     ============================================ */

  function initZoom() {
    document.querySelectorAll('.product-images .card__image-container').forEach(function(imgContainer) {
      imgContainer.addEventListener('mousemove', function(e) {
        var image = imgContainer.querySelector('img');
        if (image) {
          var clientX = e.clientX - imgContainer.offsetLeft;
          var clientY = e.clientY - imgContainer.offsetTop;
          clientX = clientX - 318;
          clientY = clientY - 327;
          image.style.transform = 'translate(-' + clientX + 'px, -' + (clientY + pageYOffset) + 'px) scale(2)';
        }
      });

      imgContainer.addEventListener('mouseleave', function() {
        var image = imgContainer.querySelector('img');
        if (image) {
          image.style.transform = 'translate(-50%, -50%) scale(1)';
        }
      });

      $(imgContainer).unbind();
      $(imgContainer).click(function() {
        var image = imgContainer.querySelector('img');
        image.classList.toggle('active_loack');
        imgContainer.classList.toggle('zoomed');
      });
    });

    document.querySelectorAll('.product-images .card__image-container img').forEach(function(image) {
      image.classList.add('active_loack');
    });
  }

  initZoom();

  document.querySelectorAll('.swatch-container.color').forEach(function(link) {
    link.addEventListener('click', function() {
      setTimeout(function() {
        initZoom();
      }, 200);
    });
  });

  /* ============================================
     Langify & Currency Form
     ============================================ */

  document.addEventListener('DOMContentLoaded', function() {
    var currencyForm = document.getElementById('currency_form');
    if (currencyForm) {
      currencyForm.addEventListener('change', function() {
        currencyForm.submit();
      });
    }
  });

  /* ============================================
     Expose functions needed by external scripts
     ============================================ */
  window.openNav = openNav;
  window.closeNav = closeNav;
  window.updatecart = updatecart;

})(jQuery);
